import React, { FC } from 'react';

import { StyledTag, StyledCloseIcon } from './styles';
import { IconColor } from '../icon/icon';

type Props = {
    label: string;
    onClose: () => void;
    className?: string;
    iconColor?: IconColor;
};

const CloseIcon = ({ onClick }) => (
    <StyledCloseIcon onClick={onClick}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.1787 9.99992L15.3029 5.87576C15.3029 5.87576 15.3029 5.87576 15.3037 5.87492C15.5196 5.65909 15.7054 5.41076 15.7054 5.28576C15.7054 5.03576 14.9646 4.29492 14.7146 4.29492C14.5887 4.29492 14.3412 4.47992 14.1246 4.69659L10.0004 8.82159L5.87541 4.69659C5.65874 4.47992 5.41124 4.29492 5.28624 4.29492C5.03624 4.29492 4.29541 5.03576 4.29541 5.28576C4.29541 5.41076 4.48041 5.65909 4.69708 5.87492L8.82208 9.99992L4.69708 14.1249C4.48041 14.3416 4.29541 14.5891 4.29541 14.7141C4.29541 14.9641 5.03624 15.7049 5.28624 15.7049C5.41124 15.7049 5.65874 15.5199 5.87541 15.3033L10.0004 11.1783L14.1254 15.3033C14.3412 15.5199 14.5896 15.7049 14.7146 15.7049C14.9646 15.7049 15.7054 14.9641 15.7054 14.7141C15.7054 14.5891 15.5204 14.3416 15.3037 14.1249L11.1787 9.99992Z"
                fill="currentColor"
            />
        </svg>
    </StyledCloseIcon>
);

const Tag: FC<Props> = ({ label, onClose, className }) => (
    <StyledTag className={className}>
        {label}
        <CloseIcon onClick={onClose} />
    </StyledTag>
);

export default Tag;
